import axios, { AxiosResponse } from "axios";
import { requests } from "./Requests";
import { PaginatedResult } from "../models/pagination";
import {
  AddPartToStockDto,
  InventoryIndexDto, 
  InventoryStockPartDetailsDto, 
  InventoryStockPartDetailsLocationDto,
  InventoryStockPartDetailsTicketDto, 
  InventoryStockPartDetailsVendorDto, 
  NewLocationFormValues,
  TicketForVendorInventoryItemDto, 
  UpdatePartNotificationSettingsDto, 
  UpdatePartToStockDto, 
  UsedQuantityDto,
  VendorForInventoryIndexDto, 
  PurchaseHistoryDto, 
  PurchasesItemDto, 
  SavePurchasesDto,
  InventoryStockPartDetailsCoresDto,
  InventoryStockCountsDto
} from "../models/inventory";
import { DropdownItemProps } from "semantic-ui-react";
import { InventoryReminderDto, SettingsInventoryDTO } from "../models/settings";
const responseBody = <T>(response: AxiosResponse<T>) => response.data;

export const inventoryIndex = {
  getInventoryIndex: (params: URLSearchParams) => axios.get<PaginatedResult<InventoryIndexDto[]>>('/InventoryIndex/getInventoryIndex', { params }).then(responseBody),
  getInventoryIndexVendor: (params: URLSearchParams) => axios.get<VendorForInventoryIndexDto>('/InventoryIndex/getInventoryIndexVendor', { params }).then(responseBody),
  getInventoryIndexTickets: (partId: string, params: URLSearchParams) =>
    axios.get<PaginatedResult<TicketForVendorInventoryItemDto[]>>(`/InventoryIndex/getInventoryIndexTickets/${partId}`, { params }).then(responseBody),
  addPartToInventory: (partToAdd: AddPartToStockDto) => requests.post<void>("/InventoryIndex/addPartInventoryStock", partToAdd),
  updatePartInInventory: (partToUpdate: UpdatePartToStockDto) => requests.put<void>(`/InventoryIndex/updatePartInventoryStock/${partToUpdate.partId}`, partToUpdate),
  removePart: (partId: string) => requests.del<void>(`/InventoryIndex/removePart/${partId}`),
  dropDownStockLocationsList: () => requests.get<DropdownItemProps[]>(`/InventoryIndex/listInventoryStockLocations`),
  updateQuantityInStock: (partId: string, usedQuantityDto: UsedQuantityDto) => requests.put<void>(`/InventoryIndex/updateQuantity/${partId}`, usedQuantityDto),
  addNewLocation: (values: DropdownItemProps) => requests.post<NewLocationFormValues>(`/InventoryIndex/newLocation`, values),
}

export const inventoryStockPartDetails = {
  getInventoryPartDetails: (partId: string) =>
    requests.get<InventoryStockPartDetailsDto>(`/InventoryPartDetails/getInventoryPartDetails/${partId}`),
  getInventoryCounts: (partIds: string[]) =>
    requests.post<InventoryStockCountsDto[]>(`/InventoryPartDetails/getInventoryCounts`, { partIds: partIds }),
  getInventoryPartVendors: (partId: string, params: URLSearchParams) =>
    axios.get<PaginatedResult<InventoryStockPartDetailsVendorDto[]>>(`/InventoryPartDetails/getInventoryPartVendors/${partId}`, { params }).then(responseBody),
  getInventoryPartLocations: (partId: string, params: URLSearchParams) =>
    axios.get<PaginatedResult<InventoryStockPartDetailsLocationDto[]>>(`/InventoryPartDetails/getInventoryPartLocations/${partId}`, { params }).then(responseBody),
  getInventoryPartCores: (partId: string, params: URLSearchParams) => axios.get<PaginatedResult<InventoryStockPartDetailsCoresDto[]>>(`/InventoryPartDetails/getCores/${partId}`, { params }).then(responseBody),
  getInventoryPartTickets: (partId: string, params: URLSearchParams) =>
    axios.get<PaginatedResult<InventoryStockPartDetailsTicketDto[]>>(`/InventoryPartDetails/getInventoryPartTickets/${partId}`, { params }).then(responseBody),
  updateNotificationSettings: (partId: string, partNotSettings: UpdatePartNotificationSettingsDto) => requests.put<void>(`/InventoryPartDetails/updatePartNotification/${partId}`, partNotSettings),
  getPurchaseHistory: (partId: string, params: URLSearchParams) => axios.get<PaginatedResult<PurchaseHistoryDto[]>>(`/InventoryPartDetails/listPurchaseHistory/${partId}`, { params }).then(responseBody),
};

export const inventoryPurchases = {
  getPurchases: (params: URLSearchParams) => axios.get<PaginatedResult<PurchasesItemDto[]>>(`/InventoryIndex/listPurchases`, { params }).then(responseBody),
  updatePurchases: (values: SavePurchasesDto) => requests.put<void>(`/InventoryIndex/updatePurchases`, values),
}

export const inventorySettings = {
  getInventorySettings: () => axios.get<SettingsInventoryDTO>(`/SettingsInventory/getSettingsInventory`, {}).then(responseBody),
  updateInventorySettings: (values: SettingsInventoryDTO) => requests.put<void>(`/SettingsInventory/updateSettingsInventory`, values),
  addInventorySettings: (values: SettingsInventoryDTO) => requests.post<void>(`/SettingsInventory/addSettingsInventory`, values),
  getInventoryReminders: () => axios.get<InventoryReminderDto[]>(`/SettingsInventory/getInventoryReminders`, {}).then(responseBody)
};